import { Injectable } from '@angular/core';
import { ServiceService } from './service.service';

@Injectable({
  providedIn: 'root'
})
export class UnidadesOrganizativasService {

  constructor( private servi: ServiceService ) {   }


  public  getInformacion() {
    return this.servi.get('UnidadesOrganizativas/getInformacion');
  }

  public GuardarUnidad(formunidad) {
    return this.servi.post(`UnidadesOrganizativas/postGuardarUnidad`, formunidad);
  }

  public cambiarEstado(id: number) {
    return this.servi.get('UnidadesOrganizativas/CambiarEstado/' + id);
  }
}
